import { Currency } from '@/core/currency/interfaces';

const VUV: Currency = {
    name: 'Vanuatu Vatu',
    demonym: 'Vanuatu',
    majorSingle: 'Vatu',
    majorPlural: 'Vatu',
    codeNumeric: '548',
    symbol: 'VT',
    symbolNative: 'VT',
    minorSingle: '',
    minorPlural: '',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'VUV',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default VUV;
